/**
 * KF-22866: BE prod có thể chưa deploy field `maxLevel` (trường hợp FE lên trước BE).
 * BE cũ không trả key này trong response, và Jackson (Jersey) mặc định fail khi gặp field lạ
 * nên gửi `maxLevel` lên sẽ bị 400 "Unrecognized field".
 *
 * Module giữ 1 cờ dùng chung cho cả trang banner ngang và banner full:
 *  - tự phát hiện từ response danh sách (không có key `maxLevel` ⇒ BE cũ),
 *  - bỏ field trước khi POST khi BE cũ,
 *  - nhận diện lỗi 400 do field lạ để tắt cờ và cho phép thử lại.
 */
let supported = true;

export function isBannerMaxLevelSupported() {
    return supported;
}

export function setBannerMaxLevelSupported(value) {
    supported = value !== false;
}

/** Response danh sách từ BE: có bản ghi nhưng KHÔNG có key maxLevel ⇒ BE cũ. */
export function detectBannerMaxLevelSupport(items) {
    if (!Array.isArray(items) || items.length === 0) return supported;
    const first = items[0];
    if (first && typeof first === 'object') {
        supported = Object.prototype.hasOwnProperty.call(first, 'maxLevel');
    }
    return supported;
}

/** Bỏ `maxLevel` khỏi payload khi BE chưa hỗ trợ (tránh 400). */
export function stripMaxLevel(payload) {
    if (!payload || supported) return payload;
    const clone = { ...payload };
    delete clone.maxLevel;
    return clone;
}

/** Lỗi 400 do field lạ `maxLevel` (Jackson: Unrecognized field). */
export function isMaxLevelUnsupportedError(error) {
    const status = error && error.response && error.response.status;
    const data = error && error.response && error.response.data;
    const message = typeof data === 'string' ? data : JSON.stringify(data || '');
    return status === 400 && /maxLevel|Unrecognized field/i.test(message);
}
